var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-right-arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-right-arrow",
    transform: "translate(-0.125000, -0.125000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.1125,31.125 C0.1125,14 14,0.1125 31.125,0.1125 C48.25,0.1125 62.1375,14 62.1375,31.125 C62.1375,48.25 48.25,62.1375 31.125,62.1375 C14,62.1375 0.1125,48.25 0.1125,31.125 Z",
    id: "Path",
    fill: "#E9791E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3875,29.7125 C50.85,26.175 47.3125,22.6375 43.775,19.1 C42.65,17.975 40.65,18.8 40.65,20.3875 C40.65,22.7 40.65,25.025 40.65,27.3375 C30.75,27.3375 20.8375,27.3375 10.9375,27.3375 C6.2,27.3375 6.15,34.6875 10.8875,34.6875 C20.8125,34.6875 30.7375,34.6875 40.6625,34.6875 C40.6625,36.9875 40.6625,39.2875 40.6625,41.5875 C40.6625,41.6625 40.675,41.725 40.675,41.8 C40.7375,42.5625 41.2,43.05 41.775,43.275 C42.35,43.5625 43.0375,43.55 43.65,43.05 C43.725,42.9875 43.8,42.925 43.875,42.85 C47.3875,39.3375 50.9,35.825 54.4125,32.3125 C55.1125,31.6 55.0875,30.425 54.3875,29.7125 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRightArrow);
export default __webpack_public_path__ + "static/media/orangeRightArrow.c9defcf698903e13923904e65e227cef.svg";
export { ForwardRef as ReactComponent };